// File: src/pages/Trader/OrdersAndWithdrawals/Settlements/components/CustomFilterModal/CustomFilterModal.tsx
import React, { useState } from 'react';
import styles from './CustomFilterModal.module.css';
import SelectType, { TItem } from './SelectType';

export type FilterValues = {
  direction: 'all' | 'M2P' | 'P2M';
  status: 'all' | 'CREATED' | 'IN_PROGRESS' | 'REJECTED' | 'COMPLETED';
  amountFrom: number | '';
  amountTo: number | '';
  dateFrom: string;
  dateTo: string;
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onApply: (vals: FilterValues) => void;
};

const defaultValues: FilterValues = {
  direction: 'all',
  status: 'all',
  amountFrom: '',
  amountTo: '',
  dateFrom: '',
  dateTo: '',
};

const directions: TItem<'all' | 'M2P' | 'P2M'>[] = [
  { id: 'all',  name: 'Все' },
  { id: 'M2P',  name: 'Мерчант → Площадка' },
  { id: 'P2M',  name: 'Площадка → Мерчант' },
];

const statuses: TItem<'all' | 'CREATED' | 'IN_PROGRESS' | 'REJECTED' | 'COMPLETED'>[] = [
  { id: 'all',         name: 'Все' },
  { id: 'CREATED',     name: 'Создана' },
  { id: 'IN_PROGRESS', name: 'В процессе' },
  { id: 'REJECTED',    name: 'Отклонена' },
  { id: 'COMPLETED',   name: 'Завершена успешно' },
];

const CustomFilterModal: React.FC<Props> = ({ isOpen, onClose, onApply }) => {
  const [vals, setVals] = useState<FilterValues>(defaultValues);
  if (!isOpen) return null;

  const change = <K extends keyof FilterValues>(field: K, v: FilterValues[K]) =>
    setVals(prev => ({ ...prev, [field]: v }));

  const apply = () => {
    onApply(vals);
    onClose();
  };

    const isInvalid =
      (!!(vals.amountFrom !== '' && vals.amountTo !== '' && vals.amountFrom > vals.amountTo)) ||
      (!!(vals.dateFrom && vals.dateTo && vals.dateFrom > vals.dateTo));


  return (
    <>
      <div className={styles.backdrop} onClick={onClose} />
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3 className={styles.title}>Пользовательский фильтр</h3>
          <button className={styles.closeBtn} onClick={onClose}>×</button>
        </div>
        <div className={styles.subtitle}>Установите необходимые параметры</div>
        <form
          className={styles.form}
          onSubmit={e => {
            e.preventDefault();
            apply();
          }}
        >
          <div className={styles.field}>
            <SelectType<'all' | 'M2P' | 'P2M'>
              title="Направление"
              items={directions}
              value={vals.direction}
              onChange={v => change('direction', v)}
            />
          </div>

          <div className={styles.field}>
            <SelectType<'all' | 'CREATED' | 'IN_PROGRESS' | 'REJECTED' | 'COMPLETED'>
              title="Статус"
              items={statuses}
              value={vals.status}
              onChange={v => change('status', v)}
            />
          </div>

          <div className={styles.row}>
            <div className={styles.field}>
              <label className={styles.label}>Сумма от</label>
              <input
                type="number"
                className={styles.input}
                value={vals.amountFrom}
                onChange={e => change('amountFrom', e.target.value ? +e.target.value : '')}
                placeholder="0"
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Сумма до</label>
              <input
                type="number"
                className={styles.input}
                value={vals.amountTo}
                onChange={e => change('amountTo', e.target.value ? +e.target.value : '')}
                placeholder="0"
              />
            </div>
          </div>

          <div className={styles.row}>
            <div className={styles.field}>
              <label className={styles.label}>Дата с</label>
              <input
                type="date"
                className={styles.input}
                value={vals.dateFrom}
                onChange={e => change('dateFrom', e.target.value)}
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Дата по</label>
              <input
                type="date"
                className={styles.input}
                value={vals.dateTo}
                onChange={e => change('dateTo', e.target.value)}
              />
            </div>
          </div>

          <button type="submit" className={styles.button} disabled={isInvalid}>
            Применить
          </button>
        </form>
      </div>
    </>
  );
};

export default CustomFilterModal;
